<script setup>
import { ref } from 'vue'
const props = defineProps({ label: { type: String, default: 'Send via' }, sendLabel: { type: String, default: 'Send' }, recipientDescription: { type: String, default: '' } })
const emit = defineEmits(['sent'])
const channels = ['Push', 'SMS', 'Email', 'WhatsApp']
const selected = ref(['Push', 'SMS'])
const toast = ref(null)
const toggle = ch => { const i = selected.value.indexOf(ch); i >= 0 ? selected.value.splice(i, 1) : selected.value.push(ch) }
const send = () => {
  if (!selected.value.length) return
  toast.value = `Sent via ${selected.value.join(', ')}${props.recipientDescription ? ' to ' + props.recipientDescription : ''} — prototype, not actually sent`
  emit('sent', { channels: [...selected.value] })
  setTimeout(() => { toast.value = null }, 2600)
}
</script>

<template>
  <div>
    <div class="form-group" style="margin-bottom:8px;">
      <label>{{ label }}</label>
      <div class="channel-chips">
        <button v-for="ch in channels" :key="ch" type="button" class="channel-chip" :class="{ selected: selected.includes(ch) }" @click="toggle(ch)">{{ ch }}</button>
      </div>
    </div>
    <button class="btn-primary" :disabled="!selected.length" @click="send">{{ sendLabel }}</button>
    <div v-if="toast" style="position:fixed;bottom:24px;right:24px;background:var(--color-primary-dark);color:#fff;padding:10px 16px;border-radius:8px;font-size:13px;box-shadow:var(--shadow-lg);z-index:120;max-width:320px;">{{ toast }}</div>
  </div>
</template>
